import { BrandingMode } from 'enums';
import { Quote, SubmissionDraft } from 'types';
import { QuoteComparisonInsightsRoutes } from 'broker/broker-routes';
import { PdfGenerationStatus } from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/QuoteComparisonInsights/types';

export interface InsightPopulatedByAI {
  result: string;
  input: { quoteIds: string[] };
}

export interface QuoteComparisonProps {
  isDirty: boolean;
  setIsDirty: (isDirty: boolean) => void;
  currentStep: QuoteComparisonInsightsRoutes;
  pdfGenerationStatus: PdfGenerationStatus;
  setPdfGenerationStatus: (pdfGenerationStatus: PdfGenerationStatus) => void;
  insightPopulatedByAI?: InsightPopulatedByAI;
  setInsightPopulatedByAI: (insight: InsightPopulatedByAI) => void;
  quotes: Quote[];
  quoteComparisonFileId: string;
  setQuoteComparisonFileId: (fileId: string) => void;
  expiringPolicyFileId?: string;
  savedDraft?: SubmissionDraft;
  brandingMode?: BrandingMode;
}

export const quoteComparisonSteps = [QuoteComparisonInsightsRoutes.Compose, QuoteComparisonInsightsRoutes.Upload];

export interface ComposeProps {
  quotes: Quote[];
  setInsightPopulatedByAI: (insight: InsightPopulatedByAI) => void;
  expiringPolicyFileId?: string;
}

export interface ComposeFromDraftProps {
  quotes: Quote[];
  expiringPolicyFileId?: string;
  savedDraft: SubmissionDraft;
}
